import React from 'react'

export const TopNavigationBar = () => {
  return (
    <div className='bg-black py-1 text-center'>
        <span className='text-white text-[12px]'><b>Welcome to HAWK NUSANTARA Official Website</b></span>
    </div>
  )
}